import { useMutation } from '@tanstack/react-query'
import { forgotPassword } from '../services/auth_service';

const useForgotPassword = () => {
 const forgotPasswordMutation = useMutation({
    mutationFn: ({ email, resetUrl }) => forgotPassword(email, resetUrl),
    onSuccess: (data) => {
    },
    onError: (error) => {
        console.error('Error sending reset password email:', error);
    }
 });
 
 return forgotPasswordMutation;
}

export default useForgotPassword; 